import React from "react";
import Typography from "@material-ui/core/Typography";
import DashboardComponente from "../components/DashboardComponente";

class Dashboard extends React.Component{

    render() {
        return (
            <div>
                    <Typography variant="h4" gutterBottom>
                        Dashboard
                    </Typography>
                    <DashboardComponente />
            </div>
        )
    }
}

export default Dashboard;